import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhotosGrid from './PhotosGrid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button, TextField } from '@mui/material';
import { Link } from 'react-router-dom';

const DiaDaMulher = () => {
    const [code, setCode] = useState('');
    const navigate = useNavigate();

    const handleCodeSubmit = () => {
        if (code.toUpperCase() === 'EUAMOAMAZON') {
            navigate('/vale-experiencia');
        } else {
            alert('Código incorreto. Tente novamente!');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleCodeSubmit();
        }
    };

    return (
        <Box sx={{ maxWidth: '1200px', margin: '0 auto', px: 2, py: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <Button 
                    component={Link} 
                    to="/" 
                    variant="outlined" 
                    sx={{
                        color: '#6a1b9a',
                        borderColor: '#6a1b9a',
                        borderRadius: '24px',
                        padding: '6px 20px',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: '#4a148c',
                            background: 'rgba(106, 27, 154, 0.1)'
                        }
                    }}
                >
                    &larr; Voltar
                </Button>
            </Box>

            <Box sx={{ textAlign: 'center', mb: 5, mt: 2, background: 'rgba(255, 255, 255, 0.6)', borderRadius: '24px', p: 4, boxShadow: '0 8px 32px rgba(123, 31, 162, 0.15)' }}>
                <Typography variant="h3" component="h1" gutterBottom className="title-text" sx={{ fontWeight: 'bold' }}>
                    Feliz dia da mulher, baby!
                </Typography>
                <Typography variant="h6" component="p" className="subtitle-text" sx={{ maxWidth: '800px', margin: '0 auto', mt: 3 }}>
                    E por meio desse compilado brega, quero demonstrar o quanto você é especial para mim.
                    <br /><br />
                    Obrigado por estar ao meu lado nesses 10+ anos, nos momentos bons e ruins.
                    Quero ver você sorrindo sempre, pois é o que me faz feliz.
                    <br /><br />
                    Bora pra cima! 💜
                </Typography>
            </Box>
            
            <PhotosGrid />
            
            <Box sx={{ textAlign: 'center', mt: 5, p: 4, background: 'rgba(255, 255, 255, 0.7)', borderRadius: '24px', boxShadow: '0 8px 32px rgba(123, 31, 162, 0.15)' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#6a1b9a' }}>
                    Uma surpresa te aguarda...
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: '#4a148c' }}>
                    Insira o código secreto que você encontrou para desbloquear.
                </Typography>
                <TextField 
                    label="Código Secreto" 
                    variant="outlined" 
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                    sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '16px' } }}
                />
                <br />
                <Button 
                    variant="contained" 
                    onClick={handleCodeSubmit}
                    sx={{
                        background: 'linear-gradient(45deg, #8e24aa, #ab47bc)',
                        color: 'white',
                        borderRadius: '16px',
                        padding: '10px 24px',
                        '&:hover': {
                            background: 'linear-gradient(45deg, #7b1fa2, #9c27b0)',
                        }
                    }}
                >
                    Desbloquear Surpresa
                </Button>
                <Typography className="footer-text" sx={{mt: 3}}>
                    {"<3"}
                </Typography>
            </Box>
        </Box>
    )
}

export default DiaDaMulher;
